module.exports = __webpack_public_path__ + "media/images/benefit-transport-507f37b0aa777e97a37b2deb64639792.svg";